export default {"src":"/_next/static/media/angle-right.28a13a49.svg","height":24,"width":25};